module.exports = __webpack_public_path__ + "static/media/opening_service.e995763b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/opening_service.pdf
// module id = 787
// module chunks = 2